import { Host, h } from "@stencil/core";
export class DnnProgressBar {
    constructor() {
        /** Sets to current value for the progress bar. */
        this.value = 0;
        /** Sets the max value for the progress bar. */
        this.max = 100;
        /** Determines if gradient colors will be used for progress bar. */
        this.useGradient = false;
    }
    getProgressClass() {
        const classes = [];
        if (this.useGradient) {
            classes.push("use-gradient");
        }
        return classes.join(" ");
    }
    render() {
        return (h(Host, { key: 'de03f469284522db6a94bf428e51a8031879a9bc' }, h("progress", { key: '37a541a01018976e50a84c297682343719d2005e', class: this.getProgressClass(), max: this.max, value: this.value })));
    }
    static get is() { return "dnn-progress-bar"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-progress-bar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-progress-bar.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "number",
                "attribute": "value",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets to current value for the progress bar."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "0"
            },
            "max": {
                "type": "number",
                "attribute": "max",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the max value for the progress bar."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "100"
            },
            "useGradient": {
                "type": "boolean",
                "attribute": "use-gradient",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determines if gradient colors will be used for progress bar."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=dnn-progress-bar.js.map
